import { useContext, useEffect, useState } from "react";
import { InterfaceContext } from "../model/InterfaceProvider";
import Modal, { ModalBackground } from "./Modal";

const ErrorModal = (props) => {
    const { errorMessage, setErrorMessage, err } = useContext(InterfaceContext);
    const pixelCoords = [0, 0];
    const [messageText, setMessageText] = useState(errorMessage);

    const closeWindow = () => {
        setErrorMessage("", err);
    };
    useEffect(() => {
        if (errorMessage) {
            setMessageText(errorMessage);
        }
    }, [errorMessage]);

    return (
        <>
            <div id={`error-window`} className={`info-box-pop show ${errorMessage ? "show" : ""}`}>
                <Modal pixelCoords={pixelCoords} visible={errorMessage} title={"Error"} pinned={errorMessage} onClose={closeWindow}>
                    <div className="mid-bar">An error occured loading the page</div>
                    <div className={"error-details"} style={{ display: "none" }}>
                        {messageText}
                        {JSON.stringify(err)}
                    </div>
                </Modal>
            </div>
        </>
    );
};
export default ErrorModal;

const ErrorModalBackground = () => {
    const { errorMessage } = useContext(InterfaceContext);
    return <ModalBackground visible={errorMessage} />;
};
export { ErrorModalBackground };
